import { GenericObject } from "utility/misc";

export default function redirectToMattermostWebhookConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/destinations/mattermost_webhook/connect");
}
